import React from 'react';

type GeoHubHeroProps = {
    cityName: string;
    subtitle: string;
    bannerSrc?: string;
};

const GeoHubHero: React.FC<GeoHubHeroProps> = ({cityName, subtitle, bannerSrc}) => {
    return (
        <header className="geo-hub-hero">
            {bannerSrc && (
                <img
                    className="geo-hub-hero__banner"
                    src={bannerSrc}
                    alt={`${cityName} dining guide banner`}
                    loading="eager"
                    decoding="async"
                />
            )}
            <div className="geo-hub-hero__content">
                <h1 className="geo-hub-hero__heading">
                    <span className="geo-hub-hero__eyebrow">Where to eat in</span>
                    <span className="geo-hub-hero__city">{cityName}</span>
                </h1>
                <p className="geo-hub-hero__subtitle">{subtitle}</p>
            </div>
        </header>
    );
};

export default GeoHubHero;
